import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (driverId, query = {}) =>
  f3tch(`/aircall/recent_calls_for/${driverId}/`)
    .profile(profile())
    .query(query)
    .get();
